import React from 'react';
import { Send, Sparkles, Utensils } from 'lucide-react';

const HowItWorks = ({ language }) => {
  const texts = {
    en: {
      title: 'How it works',
      subtitle: 'Three steps to game access.',
      steps: [
        {
          number: '1',
          icon: Send,
          title: 'Enter your number',
          description: 'Enter your mobile number on the next page.',
        },
        {
          number: '2',
          icon: Sparkles,
          title: 'Reply with JA',
          description: 'Reply with JA (for Salt and Sunrise) to activate your subscription.',
        },
        {
          number: '3',
          icon: Utensils,
          title: 'Play games',
          description: 'Play and download all provided games for the duration of your subscription.',
        },
      ],
    },
    de: {
      title: 'So funktioniert’s',
      subtitle: 'Drei Schritte zum Spielzugang.',
      steps: [
        {
          number: '1',
          icon: Send,
          title: 'Nummer eingeben',
          description: 'Gib deine Handynummer auf der nächsten Seite ein.',
        },
        {
          number: '2',
          icon: Sparkles,
          title: 'Mit JA antworten',
          description: 'Antworte mit JA (für Salt und Sunrise), um das Abo zu aktivieren.',
        },
        {
          number: '3',
          icon: Utensils,
          title: 'Spiele spielen',
          description: 'Alle bereitgestellten Spiele für die Abo-Dauer spielen und herunterladen.',
        },
      ],
    },
  };

  const t = texts[language];

  return (
    <section id="section-3" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-white mb-4">
            {t.title}
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            {t.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {t.steps.map((step, index) => (
            <div key={index} className="relative text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-brand-500/20 border border-brand-500/30 mb-6">
                <step.icon className="w-8 h-8 text-brand-400" />
              </div>
              <div className="absolute -top-1 -right-2 w-8 h-8 rounded-full bg-brand-500 text-white flex items-center justify-center text-sm font-bold">
                {step.number}
              </div>
              <h3 className="text-xl font-heading font-semibold text-white mb-3">
                {step.title}
              </h3>
              <p className="text-slate-400 leading-relaxed">
                {step.description}
              </p>
              {index < t.steps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-[60%] w-[80%] h-0.5 bg-slate-700" />
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 flex justify-center">
          <div className="rounded-2xl overflow-hidden border border-slate-700/50 max-w-md w-full aspect-[9/16] bg-slate-800/50">
            <img
              src="/images/how-it-works.jpeg"
              alt="How ChefSmarter works"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
